<template>
    <div class="max-w-4xl mx-auto bg-gray-50 p-6 sm:p-8 rounded-lg shadow-md">
        <h1 class="text-2xl font-bold text-gray-900 mb-6">{{ $translate('Billing Address') }}</h1>

        <form @submit.prevent="handleSubmit" class="space-y-6">
            <!-- Name -->
            <div>
                <label for="name" class="block text-sm font-medium text-gray-700">{{ $translate('Company Name')
                    }}</label>
                <input id="name" type="text" v-model="form.billing_address.name"
                    class="mt-1 w-full p-3 rounded-md border border-gray-300 focus:ring-blue-500 focus:border-blue-500" />
            </div>

            <!-- Address -->
            <div>
                <label for="address" class="block text-sm font-medium text-gray-700">{{ $translate('Company Address')
                    }}</label>
                <input id="address" type="text" v-model="form.billing_address.address"
                    class="mt-1 w-full p-3 rounded-md border border-gray-300 focus:ring-blue-500 focus:border-blue-500" />
            </div>

            <!-- City -->
            <div>
                <label for="city" class="block text-sm font-medium text-gray-700">{{ $translate('Company City')
                    }}</label>
                <input id="city" type="text" v-model="form.billing_address.city"
                    class="mt-1 w-full p-3 rounded-md border border-gray-300 focus:ring-blue-500 focus:border-blue-500" />
            </div>

            <!-- Zip Code -->
            <div>
                <label for="zip_code" class="block text-sm font-medium text-gray-700">{{ $translate('Company ZIP code')
                    }}</label>
                <input id="zip_code" type="text" v-model="form.billing_address.zip_code"
                    class="mt-1 w-full p-3 rounded-md border border-gray-300 focus:ring-blue-500 focus:border-blue-500" />
            </div>

            <!-- Country -->
            <div>
                <label for="country" class="block text-sm font-medium text-gray-700">{{ $translate('Country') }}</label>
                <select id="country" v-model="form.billing_address.country_id"
                    class="mt-1 w-full p-3 rounded-md border border-gray-300 focus:ring-blue-500 focus:border-blue-500">
                    <option value="58">{{ $translate('Czech Republic') }}</option>
                    <option value="200">{{ $translate('Slovak Republic') }}</option>
                </select>
            </div>

            <!-- ICO (optional) -->
            <div>
                <label for="ico" class="block text-sm font-medium text-gray-700">{{ $translate('Company Number')
                    }}</label>
                <input id="ico" type="text" v-model="form.billing_address.ico"
                    class="mt-1 w-full p-3 rounded-md border border-gray-300 focus:ring-blue-500 focus:border-blue-500" />
            </div>

            <!-- DIC (optional) -->
            <div>
                <label for="dic" class="block text-sm font-medium text-gray-700">{{ $translate('Company VAT Number')
                    }}</label>
                <input id="dic" type="text" v-model="form.billing_address.dic"
                    class="mt-1 w-full p-3 rounded-md border border-gray-300 focus:ring-blue-500 focus:border-blue-500" />
            </div>

            <!-- Submit Button -->
            <div>
                <button type="submit"
                    class="w-full bg-blue-600 text-white py-3 px-4 rounded-md font-semibold hover:bg-blue-700 transition">
                    {{ $translate('Save Billing Address') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { notify } from 'notiwind';
import { cookie } from '@/utils/cookie';

export default {
    data() {
        return {
            form: {
                billing_address: {
                    name: '',
                    address: '',
                    city: '',
                    zip_code: '',
                    country_id: '58', // Default to Czech Republic
                    ico: '',
                    dic: '',
                },
            },
        };
    },
    mounted() {
        this.fetchBillingAddress();
    },
    methods: {
        async fetchBillingAddress() {
            try {
                const response = await fetch(`${window.vueAppConfig.endpoint}/api/v2/session/account/info`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify({ session_id: cookie(), brand_id: window.vueAppConfig.info.id }),
                });

                const data = await response.json();
                if (data.status && data.data.billing_address) {
                    this.form.billing_address = {
                        name: data.data.billing_address.name || '',
                        address: data.data.billing_address.address || '',
                        city: data.data.billing_address.city || '',
                        zip_code: data.data.billing_address.zip || '',
                        country_id: data.data.billing_address.country_id || '58',
                        ico: data.data.billing_address.ico || '',
                        dic: data.data.billing_address.dic || '',
                    };
                } else {
                    notify({
                        type: 'error',
                        group: 'error',
                        title: this.$translate('Error'),
                        text: data.message || this.$translate('Billing address not found'),
                    });
                }
            } catch (error) {
                notify({
                    type: 'error',
                    group: 'error',
                    title: this.$translate('Error'),
                    text: error.message,
                });
            }
        },
        handleSubmit() {
            const payload = {
                billing_address: { ...this.form.billing_address },
                session_id: cookie(),
                brand_id: window.vueAppConfig.info.id,
            };

            fetch(`${window.vueAppConfig.endpoint}/api/v2/session/account/update`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.status) {
                        notify({
                            type: 'success',
                            group: 'info',
                            title: this.$translate('Success'),
                            text: data.message,
                        });
                    } else {
                        notify({
                            type: 'error',
                            group: 'error',
                            title: this.$translate('Error'),
                            text: data.message,
                        });
                    }
                })
                .catch((error) => {
                    notify({
                        type: 'error',
                        group: 'error',
                        title: this.$translate('Error'),
                        text: error.message,
                    });
                });
        },
    },
};
</script>